import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export const OncoCoachStatic = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname.endsWith('/') && location.pathname.length > 1) {
      navigate(location.pathname.slice(0, -1), { replace: true });
    }
  }, [location, navigate]);

  return (
    <div style={{ width: '100%', height: '100vh', overflow: 'hidden' }}>
      <iframe
        src="/_oncocoach/index.html"
        title="OncoCoach"
        style={{ width: '100%', height: '100%', border: 'none' }}
      />
    </div>
  );
};
